<script>
    import mixin from '../mixin';
    import axios from 'axios';

    import UserManagementDropdown from './UserManagementDropdown.vue';

    const regex = /^\d+\.\d{2}$/;
    const decapitalize = ([first, ...rest]) => `${first.toLowerCase()}${rest.join('')}`;
    let timeout = null;
    export default {
        mixins: [mixin],
        components: {
            UserManagementDropdown,
        },
        props: {
            api: String,
            resizable: { type: Boolean, default: false },
            sortable: { type: Boolean, default: true },
            hasCount: { type: Boolean, default: false },
            method: { type: String, default: 'post'},
            limit: { type: Number, default: 50 },
            sort: { type: String, default: 'ID'},
            sortDirection: { type: String, default: 'desc'},
            noResults: { type: String, default: 'Geen resultaten gevonden'},
            hasSearch: { type: Boolean, default: true },
            searchLabel: { type: String, default: 'Zoeken'},
            searchPlaceholder: { type: String, default: 'Zoeken in deze lijst...' },
            hasDropdown: { type: Boolean, default: false },
            extraQueries: {type: Object, default: () => {} }
        },
        data() {
            return {
                loading: true,
                search: '',
                data: null,
                page: 1,
                sortKey: null,
                sortDir: null,
                hasError: false,
                left: 0,
                positionChanged: false
            }
        },
        computed: {
            colspan() {
                let colLength = this.data.columns.length;
                if (this.hasCount) colLength++;
                if (this.hasDropdown) colLength++;
                return colLength;
            },
            queryModel() {
                let qm = {};
                if (this.extraQueries && Object.keys(this.extraQueries).length) {
                    qm = this.extraQueries;
                }
                qm.Limit = this.limit;
                qm.Offset = this.data ? (this.page - 1) * this.limit : 0;
                qm.OrderItems = this.orderItems;
                //qm.FilterItems = this.filterItems;
                qm.Text = this.search;
                return qm;
            },
            filterItems() {
                return [];
            },
            orderItems() {
                if (!this.sortKey && !this.sortDir) return [];
                return [
                    {
                        Key: this.sortKey,
                        Direction: this.sortDir,
                    }
                ]
            },
            showItems() {
                let result = this.data ? this.data.items.map((item) => {
                    let obj = {};
                    this.data.columns.forEach((col) => {
                        obj[decapitalize(col.key)] = item[decapitalize(col.key)];
                    });
                    return obj
                }) : [];
                return result;
            },
            actualItems() {
                return this.data ? this.data.items : [];
            },
        },
        methods: {
            checkResize(e) {
                this.left = e.pageX;
            },
            storeResize(e) {
                if (this.left === e.pageX) {
                    this.positionChanged = false;
                } else {
                    this.positionChanged = true;
                }
            },
            isValidDate(str) {
                let validDate = false;
                let date = new Date(str);
                let year = date.getFullYear();
                const dateFormat = Date.parse(str);
                if (date !== 'Invalid Date' && dateFormat > 0 && year <= new Date().getFullYear() && year >= new Date(new Date().setFullYear(new Date().getFullYear() - 10)).getFullYear()) {
                    validDate = true;
                }
                return validDate
            },
            findTypeByKey(key) {
                let pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
                const column = this.data.columns.find(col => col.key === pascalKey);
                return column ? column.type : null;
            },
            renderContent(val,key) {
                let type = this.findTypeByKey(key);
                if (val === null || val === undefined) {
                    return '---'
                } else if (typeof val === 'boolean') {
                    if (val) {
                        return '<i class="fa-regular fa-lg fa-square-check has-text-grey-light"></i>'
                    } else {
                        return '<i class="fa-regular fa-lg fa-square has-text-grey-light"></i>'
                    }
                } else if (typeof val === 'object') {
                    return val.alias
                } else if (typeof val === 'number' || regex.test(val)) {
                    if (type === 'moneyeur') {
                        return '€ <span class="money">' + this.toEuro(val) + '</span>'
                    } else {
                        return val
                    }
                } else if (this.isValidDate(val)) {
                    let time = new Date(val).toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' });
                    if (type === 'time') {
                        return time
                    } else if (type === 'datetime') {
                        if (time === '00:00') {
                            time = ''
                        } else {
                            time = ' ' + time;
                        }
                    } else {
                        time = '';
                    }
                    return new Date(val).toLocaleDateString('nl-NL', { day: '2-digit', month: '2-digit', year: 'numeric' }) + time
                } else {
                    return val
                }
            },
            findColumnName(key) {
                if (!this.data) return;
                return this.data.columns.find(column => column.key.toLowerCase() === key.toLowerCase()).text;
            },
            async fetchData(apiUrl, queryModel, methodType) {
                try {
                    const response = await axios({
                        method: methodType,
                        url: apiUrl,
                        data: queryModel,
                        headers: { 'Content-Type': 'application/json' },
                    })
                    return response;
                } catch (error) {
                    this.hasError = true;
                    console.log(error);
                }
            },
            async fetchInitialData() {
                this.page = 1;
                this.data = null;
                this.loading = true;
                const response = await this.fetchData(this.api, this.queryModel, this.method);
                this.setData(response);
                this.loading = false;
            },
            async sortColumn(key, currentDirection, isActive) {
                if (!this.sortable) return;
                if (this.positionChanged) return;
                this.sortKey = key.toLowerCase();
                this.sortDir = isActive ? currentDirection === 'desc' ? 'asc' : 'desc' : currentDirection;
                // reset data.columns
                this.data.columns.map(column => {
                    column.isSorted = false;
                    column.sortDirection = 'desc';
                    return column
                });
                // set data.columns
                this.data.columns.map(column => {
                    if (column.key.toLowerCase() === this.sortKey) {
                        column.isSorted = true;
                        column.sortDirection = this.sortDir;
                    }
                    return column
                });
                this.getData();
            },
            async getData() {
                const response = await this.fetchData(this.api, this.queryModel, this.method);
                if (response.status === 200) {
                    this.setData(response);
                    this.loading = false;
                    if (this.hasSearch) {
                        this.changeSearchText = this.debounce(() => {
                            this.fetchInitialData();
                        });
                    }
                }
            },
            setData(response) {
                if (!response || response.status != 200) return;
                if (!this.data) {
                    this.data = response.data;
                    this.data.facets = response.data.facets.map(facet => {
                        return {
                            ...facet,
                            values: facet.options.filter(option => option.selected).map(option => option.valueAlias),
                        }
                    });
                    this.data.columns = response.data.columns.map(column => {
                        return {
                            ...column,
                            isSorted: this.data.orderItems.some(order => order.key.toLowerCase().includes(column.key.toLowerCase())),
                            sortDirection: this.data.orderItems.some(order => order.key === column.key.toLowerCase()) ? this.data.orderItems.find(order => order.key === column.key.toLowerCase()).direction : 'desc'
                        }
                    });
                } else {
                    if (response.data.items && response.data.items.length) {
                        this.data.items = response.data.items;
                        this.data.totalCount = response.data.totalCount;
                    }
                }
            },
        },
        mounted() {
            this.sortKey = this.sort;
            this.sortDir = this.sortDirection;
        }
    }
</script>

<template>
    <div class="columns is-justify-content-end is-align-items-center">
        <div class="column is-8 is-narrow">
            <p><template v-if="data">{{data.totalCount}}</template><template v-else>0</template> items<template v-if="sortable"> • Gesorteerd op {{findColumnName(sortKey)}}, <template v-if="sortDir === 'asc'">oplopend</template><template v-else>aflopend</template></template></p>
        </div>
        <div class="column is-4 is-narrow" v-if="hasSearch">
            <div class="field is-horizontal">
                <div class="field-label is-normal" v-if="searchLabel.length">
                    <label class="label">{{searchLabel}}</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input class="input" type="search" :placeholder="searchPlaceholder" v-model="search" @input="changeSearchText">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="loading" class="has-text-centered">
        <p class="has-text-danger has-text-weight-bold mb-3" v-if="hasError">{{errorText}}</p>
        <div class="lds-facebook has-text-grey-lighter" v-else>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
    <template v-else>
        <div class="table-container" :style="{ 'overflow': this.hasDropdown ? 'visible' : '' }">
            <table class="table is-striped is-bordered table--small table-resize mb-2" v-if="resizable">
                <thead class="has-background-white">
                    <tr>
                        <th v-if="hasCount" class="count has-text-black"></th>
                        <th :class="[sortable ? 'sortable' : '', 'has-text-black', column.isSorted ? 'is-active' : '']" :title="column.text" v-for="column in data.columns" :key="column.key" @click="sortColumn(column.key,column.sortDirection, column.isSorted)" @mouseup="storeResize($event)" @mousedown="checkResize($event)"><div class="has-ellipsis resize">{{column.text}}</div> <i v-if="sortable" :class="['fa-solid', 'fa-sm', column.sortDirection === 'desc' ? 'fa-caret-down' : 'fa-caret-up']"></i></th>
                        <th v-if="hasDropdown"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="data.items.length" v-for="(row, index) in showItems" :key="row.id">
                        <td v-if="hasCount" class="count"><div class="resize auto">{{index + 1}}</div></td>
                        <td v-for="(rowVal, key) in row" :key="key" :align="typeof rowVal === 'boolean' ? 'center' : ''"><div :title="renderContent(rowVal,key)" v-html="renderContent(rowVal,key)" class="has-ellipsis resize"></div></td>
                        <td v-if="hasDropdown">
                            <user-management-dropdown :user="data.items[index]" />
                        </td>
                    </tr>
                    <tr v-else>
                        <td :colspan="colspan" align="center">{{noResults}}</td>
                    </tr>
                </tbody>
            </table>
            <table class="table is-bordered table--small mb-2" v-else>
                <thead>
                    <tr>
                        <th v-if="hasCount" class="count"></th>
                        <th :class="[sortable ? 'sortable' : '', column.isSorted ? 'is-active' : '']" v-for="column in data.columns" :key="column.key" @click="sortColumn(column.key,column.sortDirection, column.isSorted)">{{column.text}} <i v-if="sortable" :class="['fa-solid', 'fa-sm', column.sortDirection === 'desc' ? 'fa-caret-down' : 'fa-caret-up']"></i></th>
                        <th v-if="hasDropdown"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="data.items.length" v-for="(row, index) in showItems" :key="row.id">
                        <td v-if="hasCount" class="count">{{index + 1}}</td>
                        <td v-for="(rowVal, key) in row" :key="key" :align="typeof rowVal === 'boolean' ? 'center' : ''" v-html="renderContent(rowVal,key)"></td>
                        <td v-if="hasDropdown">
                            <user-management-dropdown :user="data.items[index]" />
                        </td>
                    </tr>
                    <tr v-else>
                        <td :colspan="colspan" align="center">{{noResults}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </template>
</template>
